import React from 'react';
import './Awards.css'; // optional CSS file for styles
import logo from '../assets/logo.png';
import MainMenu from '../components/MainMenu';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const Awards = () => {
  return (
    <div className="awards-page">

  <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   

      {/* Hero Section */}
      <section className="hero-banner awards-hero">
        <div className="hero-text">
          <h1>Achievements & Awards</h1>
          <p>
            The Awards and Achievements received by our school have not only enriched our legacy, but also continue to inspire
            us to work with even greater dedication and strive for excellence.
          </p>
        </div>
      </section>

      {/* Awards Section */}
      <section className="awards-section">
        <div className="container">
          <div className="awards-grid">
            <div className="award-card">
              <i className="fas fa-trophy"></i>
              <h3>Academic Excellence Award</h3>
              <p>Honored for maintaining consistent academic results and innovation in learning methodologies.</p>
            </div>
            <div className="award-card">
              <i className="fas fa-medal"></i>
              <h3>Best CBSE School Award</h3>
              <p>Acknowledged for outstanding infrastructure, teaching standards, and co-curricular activities.</p>
            </div>
            <div className="award-card">
              <i className="fas fa-star"></i>
              <h3>Innovation in Education</h3>
              <p>Recognized for introducing technology-integrated classrooms and student-led initiatives.</p>
            </div>
          </div>
        </div>
      </section>
	  
	  
	  <section className="awards-zigzag-section">
  

  <div className="zigzag-row">
    <div className="zigzag-image">
      <img src="/awards/award1.jpg" alt="Academic Excellence" />
    </div>
    <div className="zigzag-text">
      <h3>Academic Excellence Award</h3>
      <p>
        Awarded for consistently outstanding academic performance and innovation in curriculum execution.
      </p>
    </div>
  </div>

  <div className="zigzag-row reverse">
    <div className="zigzag-image">
      <img src="/awards/award2.jpg" alt="Best School Award" />
    </div>
    <div className="zigzag-text">
      <h3>Best CBSE School Award</h3>
      <p>
        Recognized for all-round excellence including infrastructure, faculty, and holistic student development.
      </p>
    </div>
  </div>

  <div className="zigzag-row">
    <div className="zigzag-image">
      <img src="/awards/award3.jpg" alt="Eco Initiatives" />
    </div>
    <div className="zigzag-text">
      <h3>Green Campus Champion</h3>
      <p>
        Honored for eco-friendly initiatives, sustainable practices, and awareness programs driven by students.
      </p>
    </div>
  </div>
</section>


      {/* Footer */}
     <Footer /> 
    </div>
  );
};

export default Awards;
